@if (gridData$ | async; as data) {
  <app-table-placeholder
    *ngIf="showPlaceholder && !data.hasData"
    class="table-placeholder"
    [text]="placeholderText"
    [htmlTextTemplate]="placeholderTextTemplate"
  />

  <ng-content *ngIf="data.hasData"></ng-content>
}
